// src/GeoGebraCalculator.js
import React, { useEffect, useRef, useState } from 'react';

let ggbScriptPromise = null;
function loadGGBScript() {
  if (window.GGBApplet) return Promise.resolve();
  if (ggbScriptPromise) return ggbScriptPromise;
  ggbScriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = '/geogebra/deployggb.js';
    s.async = true;
    s.onload = resolve;
    s.onerror = () => { ggbScriptPromise = null; reject(new Error('deployggb.js load failed')); };
    document.head.appendChild(s);
  });
  return ggbScriptPromise;
}

let ggbCounter = 0;

export default function GeoGebraCalculator() {
  const containerRef = useRef(null);
  const [error, setError] = useState(false);
  const idRef = useRef(`ggb-${++ggbCounter}`);

  useEffect(() => {
    let cancelled = false;
    loadGGBScript()
      .then(() => {
        if (cancelled || !containerRef.current) return;
        const params = {
          appName: 'suite',
          width: 760,
          height: 520,
          showToolBar: true,
          showAlgebraInput: true,
          showMenuBar: false,
          language: 'de',
          useBrowserForJS: false,
        };
        // eslint-disable-next-line no-undef
        const applet = new window.GGBApplet(params, true);
        applet.inject(idRef.current);
      })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, []);

  if (error) {
    return (
      <div style={{ padding: 20, width: 400, textAlign: 'center', color: '#a33' }}>
        GeoGebra konnte nicht geladen werden. Bitte Seite neu laden.
      </div>
    );
  }
  return <div id={idRef.current} ref={containerRef} className="ggbContainer" />;
}
